import React, { ReactNode } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";

interface ITFormAccordionProps {
    defaultExpanded?: boolean;
    detailsPadding?: string;
    title: string | ReactNode;
    subTitle?: string;
    buttons?: ReactNode;
    buttonsOnExpanded?: ReactNode;
    children: ReactNode;
    expanendedMargin?: string;
    onExpandedChange?: (expanded: boolean) => void;
}

export const FormAccordion = (props: ITFormAccordionProps) => {
    const [expanded, setExpanded] = React.useState<boolean>(props.defaultExpanded ?? false);

    const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded);
        if (props.onExpandedChange) {
            props.onExpandedChange(isExpanded);
        }
    };

    return (
        <Accordion
            elevation={0}
            sx={{
                "&.Mui-expanded": {
                    "margin": props.expanendedMargin ?? "8px 0",
                }
            }}
            expanded={expanded}
            onChange={handleChange}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    "borderLeft": "none",
                    "borderRight": "none",
                    "minHeight": "auto",
                    "& .MuiAccordionSummary-content": {
                        margin: "8px 0",
                    },
                    "&.Mui-expanded": {
                        "minHeight": "auto",
                        "& .MuiAccordionSummary-content.Mui-expanded": {
                            margin: "12px 0",
                        }
                    }
                }}
            >
                <Box display="flex" justifyContent="space-between" color="#616d7c" width="100%">
                    <Box display="flex" alignItems="center" width={!props.buttons ? "100%" : null}>
                        {props.title}
                        {props.subTitle &&
                            <Typography variant="caption" sx={{ marginLeft: "10px", marginTop: "1px" }}>{props.subTitle}</Typography>
                        }
                    </Box>
                    {(props.buttons || expanded && !!props.buttonsOnExpanded) &&
                        <Box sx={{ marginTop: "-11px", marginBottom: "-11px", marginRight: "5px", display: "flex", alignItems: "center" }}>
                            {props.buttons}
                            {expanded ? props.buttonsOnExpanded : null}
                        </Box>
                    }
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: props.detailsPadding ?? "8px 16px 0" }}>
                {props.children}
            </AccordionDetails>
        </Accordion>
    );
};
